(function(a,b){var c=function(a,b,c){var d;return function e(){function g(){if(!c)a.apply(e,f);d=null}var e=this,f=arguments;if(d)clearTimeout(d);else if(c)a.apply(e,f);d=setTimeout(g,b||20)}};jQuery.fn[b]=function(a){return a?this.bind("resize",c(a)):this.trigger(b)}})(jQuery,"smartresize")

var $masonry = $('.masonry');
var navigationTopOffset;
var navigationHeight;

jQuery(window).load(function(){
  
  
  
  
  
});

jQuery(document).ready(function($){
  
  $("a#zoom-image").fancybox({
    'padding':0,
    'titleShow': false,
    'overlayColor': '',
    'overlayOpacity': ''
  });
  
  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
  
  
  
  
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
}); // end document ready

var options =
[
// Shop ***************************************************
	{
		icon:'<a href="/pages/products"><i class="fa fa-shopping-cart"></i></a>',
		label: '<a href="/pages/products" style="color:#fff">Shop Now</a>',
		display: {
			color: '#4b4b4b',
			background: '#b5dfd6'
		}
	},
// Wholesale **********************************************
	{
		icon:'<a href="/pages/restoration"><i class="fa fa-building"></i></a>',
		label: '<a href="/pages/restoration" style="color:#fff">Wholesale</a>',
		display: {
			color: '#4b4b4b',
			background: '#b5dfd6'
		}
	}
// End Buttons ********************************************
];

var context = new Bubbler(options);